import { render, staticRenderFns } from "./LegacyImportWidget.vue?vue&type=template&id=55cb2a8e&scoped=true"
import script from "./LegacyImportWidget.vue?vue&type=script&lang=js"
export * from "./LegacyImportWidget.vue?vue&type=script&lang=js"
import style1 from "./LegacyImportWidget.vue?vue&type=style&index=1&id=55cb2a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb2a8e",
  null
  
)

export default component.exports